import { Typography } from 'seagull';
import { AttachmentsTestIds } from "./Attachments.utils";
import { jsx as _jsx } from "react/jsx-runtime";
export const AttachmentTitle = () => /*#__PURE__*/_jsx(Typography, {
  variant: "paragraph1",
  weight: "normal",
  "data-testid": AttachmentsTestIds.Title(),
  children: "Attachments"
});